/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StationAton
 */
export interface StationAton {
    /**
     * 
     * @type {Array<any>}
     * @memberof StationAton
     */
    analog?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof StationAton
     */
    digital?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof StationAton
     */
    digital2bit?: Array<any>;
}

/**
 * Check if a given object implements the StationAton interface.
 */
export function instanceOfStationAton(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StationAtonFromJSON(json: any): StationAton {
    return StationAtonFromJSONTyped(json, false);
}

export function StationAtonFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationAton {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'analog': !exists(json, 'analog') ? undefined : json['analog'],
        'digital': !exists(json, 'digital') ? undefined : json['digital'],
        'digital2bit': !exists(json, 'digital2bit') ? undefined : json['digital2bit'],
    };
}

export function StationAtonToJSON(value?: StationAton | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'analog': value.analog,
        'digital': value.digital,
        'digital2bit': value.digital2bit,
    };
}

